import { IonContent, IonList, IonIcon, IonLabel, IonItem, IonHeader, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import "./Home.css";
import readerIcon from "../assets/reader.svg";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { mk_ion_header } from "../functions/mk_ion_header";

export default function Home() {
  const { appHaeuser, appHausChange } = useContext(DataContext);

  return (
    <IonPage>
      { mk_ion_header( 'Kostenstellen' ) }
      <IonContent fullscreen>
        { mk_ion_header( 'Kostenstellen' , 'large' ) }
        <IonList>
          {appHaeuser &&
            appHaeuser.map((e: any) => (
              <IonItem
                key={"betrieb_" + e.betriebe_id}
                button
                routerLink={"/funktionen/" + e.betriebe_id + "/" + e.betriebe_name}
                onClick={() => {
                  appHausChange(e.betriebe_id);
                }}
              >
                <IonIcon slot="start" icon={readerIcon}></IonIcon>
                <IonLabel>{e.betriebe_name}</IonLabel>
              </IonItem>
            ))}
        </IonList>
      </IonContent>
    </IonPage>
  );
}
